import { render, staticRenderFns } from "./RecursosGrupoCerti.vue?vue&type=template&id=f22df9de&scoped=true"
import script from "./RecursosGrupoCerti.vue?vue&type=script&lang=js"
export * from "./RecursosGrupoCerti.vue?vue&type=script&lang=js"
import style0 from "./RecursosGrupoCerti.vue?vue&type=style&index=0&id=f22df9de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22df9de",
  null
  
)

export default component.exports